import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../../../../../../components/button';
import Modal from '../../../../../../components/modal';
import { getTimeFormat } from '../../../../../../helpers/utils-helpers';
import { IFormValues } from '../add-form/add-form.schema';
import { ChangeTypeModalSC } from './change-type-modal.styled';

interface ChangeTypeModalProps {
  visible: boolean;
  event?: IFormValues;
  setVisible: () => void;
  onSuccess: (type: 'all' | 'current') => void;
}

const ChangeTypeModal: React.FunctionComponent<ChangeTypeModalProps> = ({
  visible,
  setVisible,
  onSuccess,
  event,
}) => {
  const start = event?.fromTime ? moment(event.fromTime) : undefined;
  const end = event?.toTime ? moment(event.toTime) : undefined;
  const timeFormat = getTimeFormat(false);

  return (
    <Modal isOpen={visible} showClose onRequestClose={() => setVisible()} zIndex={100000}>
      <ChangeTypeModalSC>
        <div className="title">
          <FormattedMessage id="changeTypeModal_title" />
        </div>
        <div className="event-info">
          {start?.format('dddd')}
          <span className="time">
            {start?.format(timeFormat)} - {end?.format(timeFormat)}
          </span>
        </div>
        <div className="sub-title">
          <FormattedMessage id="changeTypeModal_subtitle" />
        </div>
        <div className="actions-wrapper">
          <Button
            kind="SECONDARY"
            isBlock
            size="SM"
            onClick={() => {
              onSuccess('current');
            }}
          >
            <FormattedMessage id="changeTypeModal_current" />
          </Button>
          <Button
            kind="PRIMARY"
            isBlock
            size="SM"
            onClick={() => {
              onSuccess('all');
            }}
          >
            <FormattedMessage id="changeTypeModal_all" />
          </Button>
        </div>
      </ChangeTypeModalSC>
    </Modal>
  );
};

export default React.memo(ChangeTypeModal);
